import { notificationsRoutes } from '@/Notifications/notifications.routes';
const notificationsModule = {
    routes: notificationsRoutes
};
export default notificationsModule;
